import { render, staticRenderFns } from "./userhome.vue?vue&type=template&id=5bfddbfb&scoped=true&"
import script from "./userhome.vue?vue&type=script&lang=js&"
export * from "./userhome.vue?vue&type=script&lang=js&"
import style0 from "./userhome.vue?vue&type=style&index=0&id=5bfddbfb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfddbfb",
  null
  
)

export default component.exports